/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyEntity,
    CurrencyEntityFromJSON,
    CurrencyEntityFromJSONTyped,
    CurrencyEntityToJSON,
} from './CurrencyEntity';
import {
    PortfolioEntity,
    PortfolioEntityFromJSON,
    PortfolioEntityFromJSONTyped,
    PortfolioEntityToJSON,
} from './PortfolioEntity';
import {
    SymbolEntity,
    SymbolEntityFromJSON,
    SymbolEntityFromJSONTyped,
    SymbolEntityToJSON,
} from './SymbolEntity';
import {
    TradeImportLogEntity,
    TradeImportLogEntityFromJSON,
    TradeImportLogEntityFromJSONTyped,
    TradeImportLogEntityToJSON,
} from './TradeImportLogEntity';
import {
    TradeTypeEnum,
    TradeTypeEnumFromJSON,
    TradeTypeEnumFromJSONTyped,
    TradeTypeEnumToJSON,
} from './TradeTypeEnum';

/**
 * 
 * @export
 * @interface TradeEntity
 */
export interface TradeEntity {
    /**
     * 
     * @type {TradeTypeEnum}
     * @memberof TradeEntity
     */
    type: TradeTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    id: string;
    /**
     * 
     * @type {CurrencyEntity}
     * @memberof TradeEntity
     */
    currency: CurrencyEntity;
    /**
     * 
     * @type {SymbolEntity}
     * @memberof TradeEntity
     */
    symbol: SymbolEntity;
    /**
     * 
     * @type {PortfolioEntity}
     * @memberof TradeEntity
     */
    portfolio: PortfolioEntity;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    portfolioId: string;
    /**
     * 
     * @type {TradeImportLogEntity}
     * @memberof TradeEntity
     */
    tradeImportLog?: TradeImportLogEntity | null;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    tradeImportLogId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TradeEntity
     */
    date: Date;
    /**
     * 
     * @type {Date}
     * @memberof TradeEntity
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TradeEntity
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof TradeEntity
     */
    unitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof TradeEntity
     */
    fees: number;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    referenceId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TradeEntity
     */
    processed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TradeEntity
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    referenceTradeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TradeEntity
     */
    brokerName?: string | null;
}

export function TradeEntityFromJSON(json: any): TradeEntity {
    return TradeEntityFromJSONTyped(json, false);
}

export function TradeEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TradeTypeEnumFromJSON(json['type']),
        'id': json['id'],
        'currency': CurrencyEntityFromJSON(json['currency']),
        'symbol': SymbolEntityFromJSON(json['symbol']),
        'portfolio': PortfolioEntityFromJSON(json['portfolio']),
        'portfolioId': json['portfolioId'],
        'tradeImportLog': !exists(json, 'tradeImportLog') ? undefined : TradeImportLogEntityFromJSON(json['tradeImportLog']),
        'tradeImportLogId': !exists(json, 'tradeImportLogId') ? undefined : json['tradeImportLogId'],
        'date': (new Date(json['date'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'amount': json['amount'],
        'unitPrice': json['unitPrice'],
        'fees': json['fees'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'processed': json['processed'],
        'deleted': json['deleted'],
        'referenceTradeId': !exists(json, 'referenceTradeId') ? undefined : json['referenceTradeId'],
        'brokerName': !exists(json, 'brokerName') ? undefined : json['brokerName'],
    };
}

export function TradeEntityToJSON(value?: TradeEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TradeTypeEnumToJSON(value.type),
        'id': value.id,
        'currency': CurrencyEntityToJSON(value.currency),
        'symbol': SymbolEntityToJSON(value.symbol),
        'portfolio': PortfolioEntityToJSON(value.portfolio),
        'portfolioId': value.portfolioId,
        'tradeImportLog': TradeImportLogEntityToJSON(value.tradeImportLog),
        'tradeImportLogId': value.tradeImportLogId,
        'date': (value.date.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'amount': value.amount,
        'unitPrice': value.unitPrice,
        'fees': value.fees,
        'note': value.note,
        'referenceId': value.referenceId,
        'processed': value.processed,
        'deleted': value.deleted,
        'referenceTradeId': value.referenceTradeId,
        'brokerName': value.brokerName,
    };
}

